export default () => {

  if ($('.source-sub-nav').length) {

    $('.source-sub-nav-mobile-trigger').click(function() {
      $(this).toggleClass('-is-active');

      $('.source-sub-nav-items').toggleClass('-open');
    });

    $('.source-sub-nav-trigger').on('click', (e) => {

      const $trigger = $(e.currentTarget),
            $item = $trigger.parents('.source-sub-nav-item'),
            $content = $item.find('.source-sub-nav-children'),
            $siblings = $item.siblings();

      $trigger
        .trigger('blur')
        .attr('aria-expanded', $item.attr('data-expanded') === 'true' ? 'false' : 'true');

      $content
        .attr('aria-hidden', $content.attr('aria-hidden') === 'true' ? 'false' : 'true')
        .slideToggle(250);

      $item
        .attr('data-expanded', $item.attr('data-expanded') === 'true' ? 'false' : 'true');

      $siblings.each((index, e) => {
        $(e).find('.source-sub-nav-trigger').attr('aria-expanded', 'false');
        $(e).find('.source-sub-nav-children').slideUp(250).attr('aria-hidden', 'true');
        $(e).attr('data-expanded', 'false');
      });

    });

  }

};
